import React from "react";

import "./DetailService.css";
function DetailService(props) {
  const wrapper = React.createRef();
  console.log(props);
  return (
    <>
      <div className="text-center" ref={wrapper}>
        <h3>{props.item.title} </h3>
        <img
          style={{ margin: "8% 0%", width: "100%" }}
          src={props.item.image}
          alt=""
        />
        <p>{props.item.description}</p>
        <h4 className="text-left">{props.item.sabTitle}</h4>
        <p className="text-left">{props.item.sabdescription}</p>
      </div>
    </>
  );
}

export default DetailService;
